import { Dialog, IconButton, IconName } from '@optimus-web/core';
import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { useDeleteCentralRateGroupMutation } from '../../../../queries';

interface Props {
    rateGroupId: string;
    onSuccess: () => void;
}

export const DeleteCentralRateGroupContainer = ({ rateGroupId, onSuccess }: Props) => {
    const { mutateAsync } = useDeleteCentralRateGroupMutation();

    const deleteCentralRateGroups = async () => {
        await mutateAsync({ centralRateGroupIds: [rateGroupId] });
        onSuccess();
    };

    const deleteAction = useDialogAction(deleteCentralRateGroups);

    return (
        <>
            <IconButton
                data-test-id={DataTestId.CentralRateGroupDeleteButton}
                icon={IconName.Delete}
                onClick={deleteAction.handlers.handleOpen}
                type="submit"
            />
            {deleteAction.states.isDialogOpened && (
                <Dialog
                    title={<LocalizedText textKey={TextKey.CentralRateGroupDeleteDialogTitle} />}
                    actions={[
                        {
                            children: <LocalizedText textKey={TextKey.Cancel} />,
                            onClick: deleteAction.handlers.handleCancel,
                            variant: 'tertiary',
                            size: 'medium',
                            type: 'button',
                        },
                        {
                            children: (
                                <LocalizedText textKey={TextKey.CentralRateGroupDeleteDialogUnlinkDeleteButton} />
                            ),
                            onClick: deleteAction.handlers.handleConfirm,
                            variant: 'destructive',
                            size: 'medium',
                            type: 'submit',
                            'data-test-id': DataTestId.CentralRateGroupDeleteButton,
                        },
                    ]}
                    active
                    loading={deleteAction.states.isProcessing}
                    onClose={deleteAction.handlers.handleCancel}
                >
                    <LocalizedText textKey={TextKey.CentralRateGroupDeleteDialogDescription} />
                </Dialog>
            )}
        </>
    );
};
